<template>
  <div class="tab-instruction">
    <el-row>
      <el-button type="primary" @click="handleRefreshColor">刷新</el-button>
    </el-row>
    <base-title title="原始订单数" class="tab-info__item-line"></base-title>
    <el-row>
      <el-table
        :data="info.originDemandsListCtx"
        style="margin-top: 10px"
        border
        stripe
      >
        <el-table-column
          :key="`originDemandsListHead-${$index}`"
          v-for="(item, $index) in info.originDemandsListHead"
          :show-overflow-tooltip="true"
          property
          :label="item"
          :min-width="150"
        >
          <template slot-scope="scope">
            <base-string :read-only="true" v-model="scope.row[$index]" label></base-string>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <base-title title="生产数" class="tab-info__item-line"></base-title>
    <el-row>
      <el-table
        :data="info.productDemandsListCtx"
        style="margin-top: 10px"
        border
        stripe
      >
        <el-table-column
          :key="`originDemandsListHead-${$index}`"
          v-for="(item, $index) in info.productDemandsListHead"
          :show-overflow-tooltip="true"
          property
          :label="item"
          :min-width="150"
        >
          <template slot-scope="scope">
            <base-string :read-only="$index === 0?true:readOnly" v-model="scope.row[$index]" label></base-string>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>
<script>
import { mixins } from "./mixins";
import baseShowCheckbox from "components/base-show-control/base-show-checkbox.vue";
export default {
  name: "tab-grid",
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  mixins: [mixins],
  components: {
    baseShowCheckbox
  },
  computed: {},
  methods: {
	  handleRefreshColor() {
		  this.$emit('handleRefreshColor');
	  }
  },
  mounted() {},
  data() {
    return {
      labelConfig: {
        readOnly: true
      },
      list: []
    };
  }
};
</script>

<style scoped>
</style>
